const copy = {
  pagination: {
    controlsLabel: "numbered pagination navigation",
    ellipsisNextLabel: "Collapsed next pages",
    ellipsisPreviousLabel: "Collapsed previous pages",
    goBackLabel: "Go to previous page",
    goForwardLabel: "Go to next page",
    goToPageLabel: (page: number): string => `Go to page ${page}`,
  },
};

export default copy;
